import { hasProp } from "../../../helpers/Class";
import Country from "../Country";
import CarrierArea from "@/classes/Billing/Carrier/CarrierArea";

class CarrierTax {
    constructor(tax = null) {
        this.id = !hasProp(tax, "id") ? undefined : tax.id;
        this.carrierId = !hasProp(tax, "carrierId") ? undefined : tax.carrierId;
        this.deliveryCountryId = !hasProp(tax, "deliveryCountryId") ? null : tax.deliveryCountryId;
        this.name = !hasProp(tax, "name") ? undefined : tax.name;
        this.value = !hasProp(tax, "value") ? undefined : tax.value;
        this.country = !hasProp(tax, "country") ? new Country() : new Country(tax.country);
        this.enabledForApi = !hasProp(tax, "enabledForApi") ? true : tax.enabledForApi;
        this.deliveryAreaId = !hasProp(tax, "deliveryAreaId") ? null : tax.deliveryAreaId;
        this.carrierArea = !hasProp(tax, "carrierArea") ? new CarrierArea() : new CarrierArea(tax.carrierArea);
        this.type = !hasProp(tax, "type") ? undefined : tax.type;
    }
}

export default CarrierTax;